<template>
  <div style="height: 100dvh; overflow-x: hidden" class="relativeclass">
    <!-- {{  showGiveFeebackButton }} -->

    <template v-if="!viewfeedback">
      <div
        class="
          newpage-head-mob
          p-3
          d-flex
          justify-content-between
          align-items-center
        "
      >
        <div>
          <img
            @click="goBack"
            class="mr-3 mb-1 pointer"
            src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
            alt=""
          />Give Feedback
        </div>
        <div @click="exportresume">
          <img src="../../assets/panelLog/mob-design/download_resume_mob.svg" />
        </div>
      </div>
      <div class="mobile-body-gfbk" style="overflow-x: hidden !important">
        <div class="mob-pan-body-gfbk pt-3 px-3 pb-1">
          <!-- Recommendation Section -->
          <div class="position-relative" v-if="showRecOptions">
            <SelectCustom
              :mandatory="true"
              :placeholder="'Select'"
              :values="getFilteredRecOptions"
              :dropdown="true"
              @select-value="
                (feedback.recOption = $event),
                  (feedback.recommendation =
                    thirdPartyData.configuration.recommendationKey[$event])
              "
              :vmodel="feedback.recOption"
              :label="'Recommendation'"
              :showError="$v.feedback.recOption.$error"
            />
            <div v-if="$v.feedback.recOption.$error" class="error-txt-tc">
              Required
            </div>
          </div>
          <div v-else class="mr-2">
            <b-form-group
              class="panlogradio"
              :class="{
                'panlogradio-err':
                  $v.feedback.recommendation.$dirty &&
                  !$v.feedback.recommendation.required,
              }"
              v-slot="{ ariaDescribedby }"
            >
              <div class="modal-subheads-mob">
                Recommendation<span class="asterik">*</span>
              </div>
              <div
                class="
                  allocateradios
                  mt-2
                  w-75
                  d-flex
                  justify-content-between
                  align-items-center
                "
              >
                <b-form-radio
                  v-model="feedback.recommendation"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="S"
                  :disabled="viewfeedback"
                  >Select</b-form-radio
                >
                <b-form-radio
                  v-model="feedback.recommendation"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  :disabled="viewfeedback"
                  value="H"
                  >Hold</b-form-radio
                >
                <b-form-radio
                  v-model="feedback.recommendation"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  :disabled="viewfeedback"
                  value="R"
                  >Reject</b-form-radio
                >
                <b-form-radio
                  v-model="feedback.recommendation"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  :disabled="viewfeedback"
                  value="DNA"
                  >No Show</b-form-radio
                >
              </div>
            </b-form-group>
          </div>

          <!-- Remarks Section -->
          <div>
            <div class="mt-3">
              <label class="modal-subheads-mob-pts">
                Remarks<span class="asterik">*</span>
              </label>
              <b-form-textarea
                class="remarks-panlog mt-2"
                type="text"
                rows="3"
                v-model.trim="$v.recruiterRemarks.$model"
                :class="{
                  'remarks-panlog-err':
                    $v.recruiterRemarks.$error ||
                    ($v.recruiterRemarks.$dirty &&
                      $v.recruiterRemarks.$required),
                }"
                placeholder="Enter"
                max-rows="3"
                no-resize
              ></b-form-textarea>
              <div v-if="!$v.recruiterRemarks.maxLength" class="error-txt-tc">
                Exceeded the max char length of 256
              </div>
              <div v-else-if="$v.recruiterRemarks.$error" class="error-txt-tc">
                Required
              </div>
            </div>
          </div>

          <!-- Candidate Info Section -->
          <div class="pr-2">
            <div class="mt-3">
              <span class="basic-info-labels mt-2 mr-3">Candidate Name</span>
              <div class="basic-info-divs-mob px-3 py-2 mt-1">
                {{ interviewCandidate }}
              </div>
            </div>
            <div class="mt-2">
              <span class="basic-info-labels mt-2 mr-3">Evaluation Date</span>
              <div class="basic-info-divs-mob px-3 py-2">{{ evalDate }}</div>
            </div>
            <div class="mt-2">
              <span class="basic-info-labels mt-2 mr-3">Panel Name</span>
              <div class="basic-info-divs-mob px-3 py-2 mt-1">
                {{ panelName }}
              </div>
            </div>
            <div class="mt-2">
              <span class="basic-info-labels mt-2 mr-3">Mode of Interview</span>
              <div class="basic-info-divs-mob px-3 py-2 mt-1">Face To Face</div>
            </div>
          </div>

          <!-- Skills Section -->
          <div
            v-if="
              feedback.recommendation != 'DNA' &&
              feedback.recommendation != 'NI' &&
              feedback.recOption != 'option7'
            "
            class="mt-3 p-1"
          >
            <div
              class="mt-2 givefdbck-blue-containers"
              :class="
                $v.feedbackform.skills.$each[inputindex].mark.$error ||
                $v.feedbackform.skills.$each[inputindex].comments.$error ||
                !$v.feedbackform.skills.$each[inputindex].mark.between ||
                !$v.feedbackform.skills.$each[inputindex].comments.maxLength
                  ? 'newInt-inner-containers-error '
                  : 'givefdbck-blue-containers'
              "
              v-for="(input, inputindex) in feedbackform.skills"
              :key="inputindex"
            >
              <div>
                <div class="newInt-inner-containers-head-1 mb-2 text-truncate">
                  {{ input.name }}
                  <span class="asterik" v-if="input.mandatory">*</span>
                </div>
                <div class="d-flex" v-if="input.markingType == 'rating'">
                  <div class="mt-2 pt-1 newInt-inner-containers-subhead-1">
                    Rating
                  </div>
                  <div>
                    <b-form-rating
                      variant="primary"
                      v-model="input.mark"
                      class="mb-2 newInt-rating p-0 w-25 ml-2"
                    ></b-form-rating>
                  </div>
                </div>
                <div v-if="input.markingType == 'score'">
                  <div class="topDiv d-flex align-items-center">
                    <div>
                      <label class="newInt-inner-containers-subhead-1"
                        >Score</label
                      >
                    </div>
                    <div class="ml-2">
                      <b-form-input
                        class="newInt-previewInputField-score no-spinner"
                        v-model="input.mark"
                        type="number"
                      ></b-form-input>
                    </div>
                    <div class="ml-2 newInt-preview-container-subFont">
                      out of 10
                      <span
                        v-if="
                          !$v.feedbackform.skills.$each[inputindex].mark.between
                        "
                        class="error-txt-tc ml-2"
                        >Should be between 1 to 10</span
                      >
                    </div>
                  </div>
                </div>
                <div class="mt-1" v-if="input.commentMode == true">
                  <div class="topDiv">
                    <div>
                      <label class="newInt-inner-containers-subhead-1"
                        >Comments</label
                      >
                    </div>
                    <div class="mt-1">
                      <b-form-textarea
                        class="newInt-previewInputField"
                        v-model="input.comments"
                        placeholder="Enter"
                        rows="3"
                        max-rows="3"
                        no-resize
                      ></b-form-textarea>
                      <div
                        v-if="
                          !$v.feedbackform.skills.$each[inputindex].comments
                            .maxLength
                        "
                        class="error-txt-tc ml-1 mt-1"
                      >
                        Exceeded the max char length of 124
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="mt-2 givefdbck-blue-containers ml-1 mr-1"
            v-if="
              feedbackform.screenshot &&
              feedback.recommendation != 'DNA' &&
              feedback.recommendation != 'NI' &&
              feedback.recOption != 'option7'
            "
            :class="showErrorImage ? 'newInt-inner-containers-error' : ''"
          >
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="d-flex align-items-center">
                <div>
                  <img
                    src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                    alt=""
                  />
                </div>
                <div class="newInt-sc-font-1 ml-2 mt-1">
                  Candidate Screenshot<span class="asterik">*</span>
                </div>
              </div>
              <div class="d-flex align-items-center" v-if="isFileUploaded">
                <div class="ucdSelDocFile position-relative">
                  <input
                    type="file"
                    multiple
                    class="pointer inputimage"
                    accept="image/jpeg, image/png"
                    @change="previewImage"
                  />
                  <img
                    src="../../assets/New-imgs/CustVend-icons/manage-replace-icon.svg"
                    alt=""
                  />
                </div>
                <div class="ml-2 mr-2">
                  <img
                    src="../../assets/New-imgs/CustVend-icons/mobVerticalLine.svg"
                    alt=""
                  />
                </div>
                <div @click="removeImage()">
                  <img
                    src="../../assets/New-imgs/CustVend-icons/mobDeleteIcon.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!isFileUploaded"
              class="
                ip-white-upload-card
                d-flex
                justify-content-between
                align-items-center
                mt-3
              "
              :class="isFailed || fileCheckImage ? 'error' : ''"
              @click="handleClick"
            >
              <div>
                <div class="ip-upload-txt">Upload File</div>
                <div class="ip-small-txt mt-1">(.png, .jpg. jpeg) max 5 mb</div>
              </div>
              <div class="d-flex align-items-center">
                <div class="errortxt text-right" v-if="isFailed">
                  Upload Failed
                </div>
                <div class="errortxt text-right" v-else-if="fileCheckImage">
                  File limit <br />exceeded
                </div>
                <div class="ip-vertical-line ml-2 mr-2"></div>
                <div class="ucdSelDocFile position-relative">
                  <input
                    @click.stop=""
                    type="file"
                    ref="fileInput"
                    multiple
                    class="pointer inputimage"
                    accept="image/jpeg, image/png"
                    @change="previewImage"
                  /><img
                    src="../../assets/panelLog/mob-design/roundUpload.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div
              class="ip-cand-ssbox mt-2 text-center"
              v-else-if="isFileUploaded"
            >
              <img
                :src="candidateImage"
                :alt="screenshotname"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
          </div>
        </div>

        <!-- Footer Section -->
        <div
          class="
            mob-pan-footer-gfbk
            d-flex
            align-items-center
            justify-content-end
          "
        >
          <div class="cancelpan-btn mr-3">
            <b-button class="addbtn h-32 w-87" @click="closeFillFeedback"
              >Cancel</b-button
            >
          </div>
          <div class="addpanellog mr-3">
            <b-button class="addbtn h-32 w-87" @click="giveFeedBack()"
              >Send</b-button
            >
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-head-mob p-3 d-flex justify-content-between">
        <div>
          <img
            @click="goBack"
            class="mr-3 mb-1 pointer"
            src="../../assets/panelLog/mob-design/bck-arr-mob-head.svg"
            alt=""
          />Preview Feedback
        </div>
        <div>
          <img
            @click="exportresume"
            src="../../assets/panelLog/mob-design/download_resume_mob.svg"
          />
        </div>
      </div>
      <div class="mobile-body-gfbk">
        <div class="mob-pan-body-gfbk p-3 h-100">
          <!-- Candidate Info Section -->
          <div class="pr-2">
            <div class="mt-3">
              <span class="basic-info-labels mt-2 mr-3">Candidate Name</span>
              <div class="basic-info-divs-mob px-3 py-2 mt-1">
                {{ basicCandInfo.name }}
              </div>
            </div>
            <div class="mt-2">
              <span class="basic-info-labels mt-2 mr-3">Evaluation Date</span>
              <div class="basic-info-divs-mob px-3 py-2">
                {{ basicCandInfo.evalDate }}
              </div>
            </div>
            <div class="mt-2">
              <span class="basic-info-labels mt-2 mr-3">Panel Name</span>
              <div class="basic-info-divs-mob px-3 py-2 mt-1">
                {{ basicCandInfo.panel }}
              </div>
            </div>
            <div class="mt-2">
              <span class="basic-info-labels mt-2 mr-3">Mode of Interview</span>
              <div class="basic-info-divs-mob px-3 py-2 mt-1">
                {{ basicCandInfo.modeOfInterview }}
              </div>
            </div>
          </div>

          <!-- Skills Section -->
          <div
            class="mt-3 p-1"
            v-if="selectedRound.skills && selectedRound.skills.length != 0"
          >
            <div
              class="mt-2 newInt-inner-containers"
              v-for="(input, inputindex) in selectedRound.skills"
              :key="inputindex"
            >
              <div>
                <div class="newInt-inner-containers-head-1 mb-2 text-truncate">
                  {{ input.name }}
                  <span v-if="input.mandatory == true" class="asterik">*</span>
                </div>
                <div class="d-flex" v-if="input.markingType == 'rating'">
                  <div class="mt-2 pt-1 newInt-inner-containers-subhead-1">
                    Rating
                  </div>
                  <div>
                    <b-form-rating
                      variant="primary"
                      v-model="input.mark"
                      disabled
                      class="mb-2 newInt-rating p-0 w-25 ml-2"
                    ></b-form-rating>
                  </div>
                </div>
                <div v-if="input.markingType == 'score'">
                  <div class="topDiv d-flex align-items-center">
                    <div>
                      <label class="newInt-inner-containers-subhead-1"
                        >Score</label
                      >
                    </div>
                    <div class="ml-2">
                      <b-form-input
                        class="newInt-previewInputField-score no-spinner"
                        v-model="input.mark"
                        type="number"
                        :max="10"
                        disabled
                        :min="1"
                      ></b-form-input>
                    </div>
                    <div class="ml-2 newInt-preview-container-subFont">
                      out of 10
                    </div>
                  </div>
                </div>
                <div class="mt-1" v-if="input.commentMode == true">
                  <div class="topDiv">
                    <div>
                      <label class="newInt-inner-containers-subhead-1"
                        >Comments</label
                      >
                    </div>
                    <div class="mt-1">
                      <b-form-textarea
                        class="newInt-previewInputField"
                        v-model="input.comments"
                        placeholder="Enter"
                        rows="3"
                        disabled
                        max-rows="3"
                      ></b-form-textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="mt-2 newInt-inner-containers ml-1 mr-1"
            v-if="allData.candidateImage"
          >
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="d-flex align-items-center">
                <div>
                  <img
                    src="../../assets/New-imgs/interviewProcess-icons/newInt-cand-screenshot.svg"
                    alt=""
                  />
                </div>
                <div class="newInt-sc-font-1 ml-2 mt-1">
                  Candidate Screenshot<span class="asterik">*</span>
                </div>
              </div>
            </div>
            <div class="ip-cand-ssbox mt-2 text-center">
              <img
                :src="allData.candidateImage"
                :alt="screenshotname"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getValidations } from "../../controllers/panelLogin/validations";
import { giveFeedBack } from "../../controllers/panelLogin/asynchronous";
import toast from "../../components/mixin/toast";
import { mob_exportResume } from "../../controllers/panelLogin/asynchronous.js";
import SelectCustom from "../../components/InputComponents/SelectCustom";

export default {
  name: "GiveFeedbackForm",
  components: { SelectCustom },
  props: {
    showPreviewFeedback: Boolean,
    evalDate: String,
    panelName: String,
    viewfeedback: Boolean,
    feedback: Object,
    feedbackform: Object,
    interviewCandidate: String,
    uploadcandheight: String,
    allpaneldata: Array,
    showfeedbackSpinner: Boolean,
    showGiveFeebackButton: Boolean,
    selectedRound: Object,
    basicCandInfo: Object,
    allData: Object,
    candidate: Object,
  },
  data() {
    return {
      interviewResponse: this.candidate,
      showErrorImage: false,
      isLaptop: true,
      recruiterRemarks: "",
      screenshotname: null,
      candidateImage: null,
      checkMedia: false,
      fileCheckImage: false,
      checkimage: false,
      isFailed: false,
      isFileUploaded: false,
      feedbackHistory: [],
      viewScreenshot: "",
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },

  created() {},

  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  mixins: [toast],

  validations() {
    return getValidations(this);
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      thirdPartyData: "getThirdPartyData",
    }),
    showRecOptions() {
      if (this.thirdPartyData.configuration?.feedbackTypeID == "FEEDBACK2")
        return true;
      return false;
    },
    getFilteredRecOptions() {
      if (this.showRecOptions) {
        return Object.entries(
          this.thirdPartyData.configuration.feedbackLevelOptions
        ).map(([key, label]) => {
          return { key, label };
        });
      }
      return [];
    },
  },

  methods: {
    async exportresume() {
      await mob_exportResume(this.candidate, this);
    },
    handleClick() {
      this.$refs.fileInput.click();
    },
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
    removeImage() {
      this.feedbackform.screenshotMedia = "";
      this.screenshotname = "";
      this.fileCheckImage = false;
      this.isFailed = false;
      this.isFileUploaded = false;
      this.showErrorImage = false;
    },
    previewImage(event) {
      const file = event.target.files[0];
      const fileType = file.type;
      const fileSize = file.size;
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];

      if (!validImageTypes.includes(fileType)) {
        this.isFailed = true;
        this.fileCheckImage = false;
        this.isFileUploaded = false;
      } else if (fileSize > 5 * 1024 * 1024) {
        this.isFailed = false;
        this.fileCheckImage = true;
        this.isFileUploaded = false;
      } else {
        this.isFailed = false;
        this.fileCheckImage = false;
        this.isFileUploaded = true;
        this.showErrorImage = false;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.isFileUploaded = true;
          this.candidateImage = e.target.result;
          this.screenshotname = file.name;
          this.feedbackform.screenshotMedia = file;
          this.showErrorImage = false;
          this.isFailed = false;
          this.fileCheckImage = false;
        };
        reader.readAsDataURL(file);
      }
    },
    async giveFeedBack() {
      this.$v.recruiterRemarks.$touch();
      await giveFeedBack(this);

      if (!this.$v.$invalid) {
        this.showErrorImage = false;
        this.$emit("giveLastFdbck");
      }
    },
    goBack() {
      this.$emit("goBack", false);
    },
    closeFillFeedback() {
      this.$v.$reset();
      this.recruiterRemarks = "";
      this.screenshotname = "";
      this.checkimage = false;
      this.isFailed = false;
      this.checkMedia = false;
      this.isFileUploaded = false;
      this.$v.recruiterRemarks.$reset();
      this.$emit("goBack", false);
    },
  },
};
</script>

<style>
.panlogradio-err .custom-control-label::before {
  width: 1rem;
  height: 1rem;

  background-color: #fff;
  border: #eb0002 solid 2px;
}
input[type="file"] {
  opacity: 0;
}
</style>
